export const uk = {
    cancel: 'Отмена',
    down: 'уменьшить',
    error: 'Нельзя {change} ставку более чем на {percent}%',
    max: 'макс',
    min: 'мин',
    'rate-string': '{change} ставку на {percent}%',
    save: 'Ок',
    up: 'увеличить'
};
